import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  // { path: '', redirectTo: '/prehome', pathMatch: 'full' },
  {
    path: 'prehome',
    loadChildren: () =>
      import('../app/modules/intro/intro.module').then((m) => m.IntroModule),
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('../app/modules/intro/intro.module').then((m) => m.IntroModule),
  },
  {
    path: 'game',
    loadChildren: () =>
      import('../app/modules/game/game.module').then((m) => m.GameModule),
  },
  {
    path: 'end',
    loadChildren: () =>
      import('../app/modules/end/end.module').then((m) => m.EndModule),
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
